// @catalog F.006
// Panel lateral de drill-down de una tienda en /ventas. Extraído de
// DashboardVentas.tsx para respetar P7 (≤500 líneas/archivo).
import { Stack, Typography } from "@mui/material";
import AnalyticsService, {
  type StoreMetrics,
} from "../../services/analytics.service";
import { DrillPanel, StatGrid } from "../analytics/DrillPanel";

export function StoreDrillPanel(props: {
  item: StoreMetrics | null;
  currentLabel: string;
  onClose: () => void;
}): JSX.Element {
  const { item, currentLabel, onClose } = props;
  return (
    <DrillPanel
      open={item !== null}
      title={item ? item.storeName : ""}
      subtitle={item ? `Tienda · ${currentLabel}` : undefined}
      onClose={onClose}
    >
      {item && (
        <Stack spacing={2}>
          <StatGrid
            items={[
              {
                label: "Ventas",
                value: AnalyticsService.formatCurrency(item.totalSales),
                helper: `${item.ordersCount} órdenes`,
              },
              {
                label: "Unidades",
                value: AnalyticsService.formatNumber(item.unitsSold),
              },
              {
                label: "Ticket prom.",
                value:
                  item.ordersCount > 0
                    ? AnalyticsService.formatCurrency(
                        item.totalSales / item.ordersCount,
                      )
                    : "—",
              },
              {
                label: "vs. año anterior",
                value:
                  item.growthPercentage !== undefined &&
                  item.growthPercentage !== null
                    ? `${item.growthPercentage >= 0 ? "+" : ""}${item.growthPercentage.toFixed(1)}%`
                    : "Sin base",
              },
            ]}
          />
          <Typography
            variant="caption"
            sx={{ color: "var(--ink-3)", fontSize: "12px" }}
          >
            Datos disponibles en el endpoint actual de tiendas (sin desglose por
            producto). Para drill-down detallado a productos por tienda, ver
            módulo /margenes.
          </Typography>
        </Stack>
      )}
    </DrillPanel>
  );
}
